export default __webpack_public_path__ + "static/media/contact_menu.c0c43488.svg";